import { render, staticRenderFns } from "./SidebarSearch.vue?vue&type=template&id=26ed6f0a&scoped=true"
import script from "./SidebarSearch.vue?vue&type=script&lang=js"
export * from "./SidebarSearch.vue?vue&type=script&lang=js"
import style0 from "./SidebarSearch.vue?vue&type=style&index=0&id=26ed6f0a&prod&lang=scss&scoped=true"
import style1 from "./SidebarSearch.vue?vue&type=style&index=1&id=26ed6f0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ed6f0a",
  null
  
)

export default component.exports